import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { SceneController } from './pages/SceneController';
import { BudgetController } from './pages/BudgetController';
import { Sidebar } from './components/Sidebar';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1">
        <Sidebar data-id="element-2" />
        <div className="flex-1" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Dashboard data-id="element-6" />} data-id="element-5" />
            <Route path="/scenes" element={<SceneController data-id="element-8" />} data-id="element-7" />
            <Route path="/budget" element={<BudgetController data-id="element-10" />} data-id="element-9" />
          </Routes>
        </div>
      </div>
    </BrowserRouter>;
}